import React from 'react';

const TarifaTmovContext = React.createContext();

export default TarifaTmovContext;
